import { type SearchUserAppRoleViewQuery } from '@user-management/graphql';
import { type UserStatus } from '@user-management/role-user-management';

import { type RoleUserListRowItem } from './columns';

export function mapAppRolesUserList(
  users: SearchUserAppRoleViewQuery['getUserAppRoleView']['users'],
) {
  const mappedArray = users.map((user) => {
    const mappedObject: RoleUserListRowItem = {
      profile: {
        firstName: user.firstname,
        lastName: user.lastname,
        email: user.email ?? '-',
        profilePic: '',
      },
      userId: user.id,
      status: (user.status ?? '-') as UserStatus,
      lastLoginAt: user.lastLoginAt ?? '',
      invitationExpireAt: user.invitationExpireAt,
    };
    return mappedObject;
  });
  return mappedArray;
}
